import { createSlice } from '@reduxjs/toolkit';
import { PartnerState } from './model';
import * as reducers from './reducers';

const slice = createSlice<PartnerState, typeof reducers>({
  name: 'contracts',
  initialState: {},
  reducers: {
    ...reducers,
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;
